import React from 'react';

import { SatCheckBox, SatToolTip } from '@components/common/satUI';
import { NTCE_SCREN_DISP_METH_CD } from '@common/constants';

/**
 * 계약이전고지화면표시방법코드 (B1)
 * 문구전 체크박스
 * @param {*} props
 * @returns
 */
const CheckBoxBeforeAns = props => {
  const {
    isPreUw = false,
    group,
    items,
    prevItems,
    noticeDutyTooltips,
    setNoticeDutyTooltips,
    tbNbsPolicyBfNtceAnsDtlDTO,
    tbNbsPolicyBfNtceAnsByitmDtlDTO,
    setTbNbsPolicyBfNtceAnsByitmDtlDTO,
    onSave,
  } = props;

  const onChange = (item, value) => {
    let newTbNbsPolicyBfNtceAnsByitmDtlDTO;

    const prevItem = tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
      itmDtl =>
        itmDtl.policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
        itmDtl.policyBfNtceItmNo === item.policyBfNtceItmNo,
    );

    if ($utils.isEmptyObject(prevItem)) {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = [
        ...tbNbsPolicyBfNtceAnsByitmDtlDTO,
        {
          ansContn: value ? 'Y' : 'N',
          ansDataTyTpCd: '2',
          policyBfNtceId: '',
          policyBfNtceItmGrpNo: item.policyBfNtceItmGrpNo,
          policyBfNtceItmNo: item.policyBfNtceItmNo,
        },
      ];
    } else {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = tbNbsPolicyBfNtceAnsByitmDtlDTO.map(
        itmDtl => {
          if (
            itmDtl.policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
            itmDtl.policyBfNtceItmNo === item.policyBfNtceItmNo
          ) {
            return {
              ...itmDtl,
              ansContn: value ? 'Y' : 'N',
            };
          }
          return itmDtl;
        },
      );
    }

    setTbNbsPolicyBfNtceAnsByitmDtlDTO(newTbNbsPolicyBfNtceAnsByitmDtlDTO);
    onSave(
      value,
      { group, item },
      {
        tbNbsPolicyBfNtceAnsDtlDTO,
        tbNbsPolicyBfNtceAnsByitmDtlDTO: newTbNbsPolicyBfNtceAnsByitmDtlDTO,
      },
    );
  };

  const getCheckBoxStyle = length => {
    if (length === 5) {
      return 'divide-5';
    } else if (length >= 9) {
      return 'divide-3';
    } else {
      return 'divide-4';
    }
  };

  return (
    <div
      className={`check-box${
        items.find(
          item =>
            item.policyBfNtceScrenDispMethdCd === NTCE_SCREN_DISP_METH_CD.NONE,
        )
          ? '-bg full'
          : ''
      } renew ${getCheckBoxStyle(
        items.filter(
          item =>
            item.policyBfNtceScrenDispMethdCd ===
            NTCE_SCREN_DISP_METH_CD.CHECK_BOX,
        ).length,
      )}`}
    >
      {items
        .filter(
          item =>
            item.policyBfNtceScrenDispMethdCd ===
            NTCE_SCREN_DISP_METH_CD.CHECK_BOX,
        )
        .map(item => {
          const tooltips = $utils.getMetaInfo(item, 'tooltip');
          return (
            <div
              className={`${tooltips.length > 0 ? 'box-item-tootip' : ''}`}
              key={`checkbox_${item.policyBfNtceItmNo}`}
            >
              <SatCheckBox
                disabled={isPreUw}
                key={item.policyBfNtceItmNo}
                options={[
                  {
                    label: item.itmDispContn,
                    value: item.policyBfNtceItmNo,
                  },
                ]}
                value={[
                  $utils.isTrue(
                    tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
                      dtl =>
                        dtl.policyBfNtceItmGrpNo ===
                          group.policyBfNtceItmGrpNo &&
                        dtl.policyBfNtceItmNo === item.policyBfNtceItmNo,
                    )?.ansContn,
                  ),
                ]}
                onChange={value => {
                  onChange(item, value);
                }}
              />
              {tooltips.length > 0 && (
                <SatToolTip
                  show={noticeDutyTooltips[$utils.getMetaInfoId(tooltips[0])]}
                  setShow={flag => {
                    setNoticeDutyTooltips({
                      ...noticeDutyTooltips,
                      [$utils.getMetaInfoId(tooltips[0])]: flag,
                    });
                  }}
                  toolTips={tooltips.map(info => ({
                    message: () => <p>{info.dispContn}</p>,
                  }))}
                />
              )}
            </div>
          );
        })}
    </div>
  );
};

export default CheckBoxBeforeAns;
